/* eslint-disable @typescript-eslint/no-explicit-any */
import { Layer } from '@carto/kepler.gl/layers'
import { isUnknownSpatialSettingsDataset } from 'features/builder/state/builderSliceUtils'
import IconTilesets from 'assets/icons/layers/tilesets.svg?react'
import { KeplerTable, LayerTypes, KeplerLayer, FindDefaultLayerResult } from 'features/builder/types'
import { createNewLayerColorGenerator } from './colorUtils'

export default class UnknownLayer extends Layer {
  [x: string]: any
  static type: string

  constructor(props = {}) {
    super(props)
    this.registerVisConfig({})
  }

  public get type() {
    return LayerTypes.Unknown
  }

  get name() {
    return '???'
  }

  get layerIcon() {
    return IconTilesets
  }

  get canDropFeatures() {
    return true
  }

  get visualChannels(): any {
    return {}
  }

  static findDefaultLayerProps(dataset: unknown, foundLayers: unknown[]): FindDefaultLayerResult {
    const emptyProps = { props: [] }

    if (foundLayers?.length) {
      return emptyProps
    }

    if (isUnknownSpatialSettingsDataset(dataset as KeplerTable)) {
      return {
        props: [
          {
            label: (dataset as KeplerTable).label,
            isVisible: false,
            columns: {}
          }
        ]
      }
    }
    return emptyProps
  }

  getDefaultLayerConfig(props = {}): any {
    const baseConfig = super.getDefaultLayerConfig(props)
    return {
      ...baseConfig,
      initialLayerColor: baseConfig.color
    }
  }

  getNewLayerConfig(dataset: KeplerTable, otherLayers: KeplerLayer[]): Record<string, any> {
    const colorGenerator = createNewLayerColorGenerator(
      otherLayers.filter((layer) => layer !== (this as unknown as KeplerLayer))
    )
    const color = colorGenerator()
    const strokeColor = colorGenerator()
    return {
      color,
      visConfig: {
        ...this.config.visConfig,
        strokeColor,
        initialStrokeColor: strokeColor
      }
    }
  }

  getHoverData(object: any) {
    if (!object) {
      return null
    }

    return object.properties
  }

  formatLayerData() {
    return {
      data: []
    }
  }

  hasLayerData() {
    return false
  }

  renderLayer() {
    return []
  }
}
